import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { AgUiTool } from "@strands/agent-transport";

export interface ChatActions {
  registerTool: (tool: AgUiTool) => () => void;
  sendToolResult: (toolCallId: string, content: string) => Promise<void>;
  /** Resume a Strands HITL interrupt with the user's decision. `"A"` =
   *  approve, `"D"` = deny. The agent re-runs the paused tool call and
   *  either executes it (approve) or records a cancellation (deny). */
  respondToInterrupt: (interruptId: string, response: "A" | "D") => Promise<void>;
}

const ChatActionsContext = createContext<ChatActions | null>(null);

export function ChatActionsProvider({
  value,
  children,
}: {
  value: ChatActions;
  children: ReactNode;
}) {
  return <ChatActionsContext.Provider value={value}>{children}</ChatActionsContext.Provider>;
}

export function useChatActions(): ChatActions {
  const ctx = useContext(ChatActionsContext);
  if (!ctx) {
    throw new Error("useChatActions must be used inside <ChatActionsProvider>");
  }
  return ctx;
}
